module.exports = __webpack_public_path__ + "img/Brand_atlassian.e8fbb346.svg";